export const createBeforeBreadcrumb = () => {
    return (breadcrumb, hint) => {
        const { category } = breadcrumb;
        const isUiInteractionBreadcrumb = category && (category === 'ui.click' || category === 'ui.input');
        const targetElement = hint && hint.event && hint.event.target;
        if (isUiInteractionBreadcrumb && targetElement) {
            const nodeWithDataHook = targetElement.closest('[data-hook]');
            if (nodeWithDataHook) {
                const dataHook = nodeWithDataHook.getAttribute('data-hook');
                if (targetElement === nodeWithDataHook) {
                    breadcrumb.message = `${breadcrumb.message} [data-hook="${dataHook}"]`;
                }
                else {
                    breadcrumb.message = `${breadcrumb.message} parent:[data-hook="${dataHook}"]`;
                }
            }
        }
        return breadcrumb;
    };
};
//# sourceMappingURL=beforeBreadcrumb.js.map